import React from 'react'
import { Breadcrumbs } from 'src/components/Breadcrumbs'
import { listsRoute } from 'src/consts'
import Link from 'next/link'
import Image from 'next/image'
import styles from './styles.module.scss'
import ListAuthor from 'src/components/ListAuthor'
import { update } from 'lodash'

export const ListDetailsHeader = ({
  title,
  shortPreview,
  author,
  mainImage,
  upperContent,
  updatedAt,
}) => {
  const listsBreadrumbs = [{ breadcrumb: 'Top lists', href: listsRoute() }]

  return (
    <main className={styles.header}>
      <div className={styles.header__container}>
        <Breadcrumbs
          items={listsBreadrumbs}
          lastItem={title}
          wrapperClassName={styles.breadcrumbs}
        />
        <section className={styles.header__section}>
          <div className={styles.heading}>
            <h1 className={styles.heading__title}>{title}</h1>
            <ListAuthor
              authorData={{
                authorSlug: author?.data?.attributes.slug,
                authorImage:
                  author?.data?.attributes?.image?.data?.attributes.url,
                authorFullName: author?.data?.attributes?.fullName,
                createdAt: updatedAt,
              }}
            />
          </div>
          <article className={styles.listArticle}>
            <div
              className={styles.textContent}
              dangerouslySetInnerHTML={{
                __html: upperContent,
              }}
            />
          </article>

          <div className={styles.header__imageContainer}>
            <Image
              src={mainImage?.data?.attributes?.url}
              alt='header image'
              className={styles.header__image}
              objectFit='cover'
              layout='fill'
              loading='lazy'
            />
          </div>
        </section>
      </div>
    </main>
  )
}
